import { FunctionComponent } from 'react'
import { Grid } from '@mui/material'
import { MyAccountFieldTemplateProps } from '../../../../common/model/MyAccountFieldTemplateProps'
import fieldTemplateStyles from './fieldTemplate.styles'

const FieldTemplate: FunctionComponent<MyAccountFieldTemplateProps> = props => {
  const { children, uiSchema } = props
  const styles = fieldTemplateStyles()

  const breakpoints = uiSchema['ui:options']?.props?.breakpoints

  return (
    <Grid
      item
      className={styles.item}
      {...(breakpoints ? { ...breakpoints } : { xs: 12 })}
    >
      {children}
    </Grid>
  )
}

export default FieldTemplate
